export const invoiceState = {
  invoiceData: null,
  invoiceList: null,
  invoiceListFilter: {
    search_str: "",
    invoiceStatuses: "",
    invoice_project_id: null,
    invoice_user_id: null,
    start_from: 0,
  },

  invoiceDetails: {},
  invoice_list_start_from: 0,
  invoice_list_scrolltop: 0,
};
